var br = Object.defineProperty;
var xr = (n, r, a) => r in n ? br(n, r, { enumerable: !0, configurable: !0, writable: !0, value: a }) : n[r] = a;
var Je = (n, r, a) => xr(n, typeof r != "symbol" ? r + "" : r, a);
import ne from "axios";
import me, { useState as ee, useRef as re, useEffect as te, useCallback as L, createContext as wr, useContext as Sr } from "react";
var x = /* @__PURE__ */ ((n) => (n.JWT = "cas_jwt", n.USER = "cas_user", n.REDIRECT_PATH = "cas_redirect_path", n.REDIRECT_COUNT = "cas_redirect_count", n))(x || {});
const R = {
  /**
   * Store JWT token in local storage
   */
  setToken(n, r = x.JWT) {
    try {
      localStorage.setItem(r, n);
    } catch (a) {
      console.error("[CAS Auth] Failed to store token:", a);
    }
  },
  /**
   * Retrieve JWT token from local storage
   */
  getToken(n = x.JWT) {
    try {
      return localStorage.getItem(n);
    } catch (r) {
      return console.error("[CAS Auth] Failed to retrieve token:", r), null;
    }
  },
  /**
   * Remove JWT token from local storage
   */
  removeToken(n = x.JWT) {
    try {
      localStorage.removeItem(n);
    } catch (r) {
      console.error("[CAS Auth] Failed to remove token:", r);
    }
  },
  /**
   * Store user information in local storage
   */
  setUser(n) {
    try {
      localStorage.setItem(x.USER, JSON.stringify(n));
    } catch (r) {
      console.error("[CAS Auth] Failed to store user:", r);
    }
  },
  /**
   * Retrieve user information from local storage
   */
  getUser() {
    try {
      const n = localStorage.getItem(x.USER);
      return n ? JSON.parse(n) : null;
    } catch (n) {
      return console.error("[CAS Auth] Failed to retrieve user:", n), null;
    }
  },
  /**
   * Remove user information from local storage
   */
  removeUser() {
    try {
      localStorage.removeItem(x.USER);
    } catch (n) {
      console.error("[CAS Auth] Failed to remove user:", n);
    }
  },
  /**
   * Store redirect path for post-login navigation
   */
  setRedirectPath(n) {
    try {
      localStorage.setItem(x.REDIRECT_PATH, n);
    } catch (r) {
      console.error("[CAS Auth] Failed to store redirect path:", r);
    }
  },
  /**
   * Retrieve and remove redirect path
   */
  getAndClearRedirectPath() {
    try {
      const n = localStorage.getItem(x.REDIRECT_PATH);
      return n && localStorage.removeItem(x.REDIRECT_PATH), n;
    } catch (n) {
      return console.error("[CAS Auth] Failed to retrieve redirect path:", n), null;
    }
  },
  /**
   * Get redirect count for infinite loop protection
   */
  getRedirectCount() {
    try {
      const n = localStorage.getItem(x.REDIRECT_COUNT);
      return n ? parseInt(n, 10) : 0;
    } catch (n) {
      return console.error("[CAS Auth] Failed to retrieve redirect count:", n), 0;
    }
  },
  /**
   * Increment redirect count
   */
  incrementRedirectCount() {
    try {
      const n = this.getRedirectCount() + 1;
      return localStorage.setItem(x.REDIRECT_COUNT, n.toString()), n;
    } catch (n) {
      return console.error("[CAS Auth] Failed to increment redirect count:", n), 1;
    }
  },
  /**
   * Reset redirect count (call after successful authentication)
   */
  resetRedirectCount() {
    try {
      localStorage.removeItem(x.REDIRECT_COUNT);
    } catch (n) {
      console.error("[CAS Auth] Failed to reset redirect count:", n);
    }
  },
  /**
   * Clear all CAS authentication data
   */
  clearAll(n = x.JWT) {
    this.removeToken(n), this.removeUser(), localStorage.removeItem(x.REDIRECT_PATH), localStorage.removeItem(x.REDIRECT_COUNT);
  },
  /**
   * Generic set item in localStorage
   */
  setItem(n, r) {
    try {
      localStorage.setItem(n, r);
    } catch (a) {
      console.error("[CAS Auth] Failed to store item:", a);
    }
  },
  /**
   * Generic get item from localStorage
   */
  getItem(n) {
    try {
      return localStorage.getItem(n);
    } catch (r) {
      return console.error("[CAS Auth] Failed to retrieve item:", r), null;
    }
  },
  /**
   * Generic remove item from localStorage
   */
  removeItem(n) {
    try {
      localStorage.removeItem(n);
    } catch (r) {
      console.error("[CAS Auth] Failed to remove item:", r);
    }
  }
};
function oe(n) {
  try {
    const r = n.split(".");
    if (r.length !== 3)
      return console.error("[CAS Auth] Invalid JWT format"), null;
    const a = r[1], i = atob(a.replace(/-/g, "+").replace(/_/g, "/"));
    return JSON.parse(i);
  } catch (r) {
    return console.error("[CAS Auth] Failed to decode JWT:", r), null;
  }
}
function _r(n) {
  const r = oe(n);
  if (!r || !r.exp)
    return !0;
  const a = r.exp, i = Math.floor(Date.now() / 1e3);
  return a < i;
}
function Be(n) {
  const r = oe(n);
  if (!r || !r.exp)
    return null;
  const a = r.exp, i = Math.floor(Date.now() / 1e3), h = a - i;
  return Math.floor(h / 60);
}
function Lr(n) {
  const r = oe(n);
  if (!r || !r.exp)
    return null;
  const a = r.exp, i = Math.floor(Date.now() / 1e3);
  return a - i;
}
function kr(n, r) {
  const a = Be(n);
  return a === null ? !0 : a <= r;
}
function ze(n) {
  const r = oe(n);
  return r ? {
    token: n,
    username: r.sub || r.username || r.uid,
    email: r.email,
    name: r.name,
    umid: r.umid,
    exp: r.exp,
    iat: r.iat,
    attributes: r.attributes
  } : null;
}
function Ye(n) {
  if (!n)
    return {
      valid: !1,
      error: "No token provided"
    };
  if (_r(n))
    return {
      valid: !1,
      expired: !0,
      error: "Token expired"
    };
  const r = ze(n);
  return !r || !r.username ? {
    valid: !1,
    error: "Invalid token payload"
  } : {
    valid: !0,
    user: r
  };
}
class Ar {
  constructor(r) {
    Je(this, "config");
    this.config = {
      ...r,
      storageKey: r.storageKey || "cas_jwt",
      debug: r.debug || !1,
      maxRedirects: r.maxRedirects || 3
    }, this.log("CAS Auth Manager initialized", this.config);
  }
  log(...r) {
    this.config.debug && console.log("[CAS Auth]", ...r);
  }
  error(...r) {
    console.error("[CAS Auth]", ...r);
  }
  /**
   * Check if user has a valid session
   */
  hasValidSession() {
    const r = R.getToken(this.config.storageKey);
    if (!r)
      return this.log("No token found in storage"), !1;
    const a = Ye(r);
    return a.valid ? (this.log("Valid session found"), R.resetRedirectCount(), !0) : (this.log("Token validation failed:", a.error), !1);
  }
  /**
   * Get the current user from storage
   */
  getCurrentUser() {
    const r = R.getToken(this.config.storageKey);
    if (!r)
      return null;
    const a = Ye(r);
    return !a.valid || !a.user ? null : a.user;
  }
  /**
   * Check if URL contains a CAS ticket parameter
   */
  hasTicketInURL() {
    return new URLSearchParams(window.location.search).has("ticket");
  }
  /**
   * Extract CAS ticket from URL
   */
  getTicketFromURL() {
    return new URLSearchParams(window.location.search).get("ticket");
  }
  /**
   * Redirect to CAS login page with infinite loop protection
   */
  redirectToLogin() {
    if (R.getRedirectCount() >= this.config.maxRedirects)
      return this.error(
        `Already redirected to CAS ${this.config.maxRedirects} times. Cannot redirect again.`,
        "Please refresh the page to try again or contact support."
      ), R.clearAll(this.config.storageKey), !1;
    this.log("Redirecting to CAS login"), R.incrementRedirectCount();
    const a = window.location.pathname + window.location.hash;
    R.setRedirectPath(a);
    const i = `${this.config.casLoginUrl}?service=${encodeURIComponent(this.config.serviceUrl)}`;
    return this.log("Login URL:", i), window.location.href = i, !0;
  }
  /**
   * Exchange CAS ticket for JWT token
   */
  async exchangeTicketForToken(r) {
    var a;
    this.log("Exchanging ticket for JWT token");
    try {
      const i = await ne.get(this.config.apiGatewayUrl, {
        params: {
          serviceUrl: this.config.serviceUrl,
          ticket: r
        },
        headers: {
          "Content-Type": "application/json"
        }
      });
      if (!i.data || !i.data.token)
        throw new Error("Invalid response from authentication server");
      const h = i.data.token;
      this.log("Received JWT token from backend"), R.resetRedirectCount(), R.setToken(h, this.config.storageKey);
      let T = ze(h);
      if (!T)
        throw new Error("Failed to extract user from token");
      if (this.config.onUserFetch)
        try {
          this.log("Fetching additional user data via callback"), T = await this.config.onUserFetch(h, T), this.log("User data fetched successfully");
        } catch (l) {
          throw ne.isAxiosError(l) && ((a = l.response) == null ? void 0 : a.status) === 404 ? (this.error("User not found in system (404)"), R.clearAll(this.config.storageKey), this.config.onUserNotFound && this.config.onUserNotFound(), new Error("User not found in system")) : (this.error("Failed to fetch user data:", l), R.clearAll(this.config.storageKey), l);
        }
      return R.setUser(T), this.log("User authenticated:", T.username), T;
    } catch (i) {
      throw this.error("Token exchange failed:", i), i;
    }
  }
  /**
   * Clean up URL after CAS redirect (remove ticket parameter)
   */
  cleanupURL() {
    const r = this.getTicketFromURL();
    if (r) {
      const i = window.location.pathname + window.location.search.replace(`ticket=${r}`, "").replace(/^&/, "?").replace(/\?&/, "?").replace(/\?$/, "");
      window.history.replaceState({}, document.title, i);
    }
    const a = R.getAndClearRedirectPath();
    a && (this.log("Restoring original path:", a), window.history.replaceState({}, document.title, a));
  }
  /**
   * Logout user and clear session
   */
  logout() {
    this.log("Logging out user"), R.clearAll(this.config.storageKey);
    const r = this.config.casLoginUrl.replace("/login", "/logout");
    window.location.href = r;
  }
  /**
   * Get the stored JWT token
   */
  getToken() {
    return R.getToken(this.config.storageKey);
  }
  /**
   * Add Authorization header to axios request config
   */
  addAuthHeader(r) {
    const a = this.getToken();
    return a ? {
      ...r,
      headers: {
        ...r.headers || {},
        Authorization: `Bearer ${a}`
      }
    } : r;
  }
  /**
   * Refresh the JWT token by performing a silent redirect to CAS
   * If the CAS session (TGT) is still valid, this will be transparent to the user
   * If the CAS session expired, user will be prompted to log in again
   */
  async refreshToken() {
    this.log("Refreshing JWT token via silent CAS redirect"), R.setItem("cas_silent_refresh", "true");
    const r = window.location.pathname + window.location.search + window.location.hash;
    R.setRedirectPath(r);
    const a = `${this.config.casLoginUrl}?service=${encodeURIComponent(this.config.serviceUrl)}`;
    return this.log("Redirecting to CAS for silent refresh:", a), window.location.href = a, new Promise(() => {
    });
  }
}
function jr(n) {
  var H;
  const [r, a] = ee({
    user: null,
    isLoading: !0,
    error: null
  }), [i] = ee(() => new Ar(n)), h = re(!1), [T, l] = ee(!1), [j, y] = ee(0), _ = re(null), v = re(null), C = re(null), P = n.enableAutoRefresh !== !1, U = n.refreshWarningMinutes || 10, Y = n.refreshWarningDurationSeconds || 30;
  te(() => {
    const k = R.getRedirectCount();
    k > 0 && (console.log("[CAS Auth] Clearing stale redirect count from previous session:", k), R.resetRedirectCount());
  }, []);
  const N = L((k, b) => {
    typeof document < "u" && (document.dispatchEvent(new CustomEvent("auth-state-change", {
      detail: { authenticated: k, user: b },
      bubbles: !0
    })), k && b && document.dispatchEvent(new CustomEvent("access-granted", {
      detail: { authenticated: k, user: b },
      bubbles: !0
    })));
  }, []);
  te(() => {
    (async () => {
      try {
        if (i.hasTicketInURL()) {
          const b = i.getTicketFromURL();
          if (b) {
            const I = await i.exchangeTicketForToken(b);
            i.cleanupURL(), a({
              user: I,
              isLoading: !1,
              error: null
            }), N(!0, I);
            return;
          }
        }
        if (i.hasValidSession()) {
          const b = i.getCurrentUser();
          a({
            user: b,
            isLoading: !1,
            error: null
          }), N(!0, b);
          return;
        }
        h.current || (h.current = !0, i.redirectToLogin());
      } catch (b) {
        const I = b instanceof Error ? b.message : "Authentication failed";
        a({
          user: null,
          isLoading: !1,
          error: I
        }), N(!1, null);
      }
    })();
  }, [i, N]);
  const ae = L(() => {
    i.logout();
  }, [i]), O = L(() => i.getToken(), [i]), E = L(
    (k) => i.addAuthHeader(k),
    [i]
  );
  te(() => () => {
    _.current && clearTimeout(_.current), v.current && clearInterval(v.current), C.current && clearInterval(C.current);
  }, []);
  const ie = L(() => {
    _.current && clearTimeout(_.current), v.current && clearInterval(v.current), l(!1), i.refreshToken();
  }, [i]), $ = L(() => {
    if (C.current && clearInterval(C.current), !i.getToken())
      return;
    const b = () => {
      const I = i.getToken();
      I && kr(I, U) && (C.current && clearInterval(C.current), l(!0), y(Y), v.current = setInterval(() => {
        y((q) => q <= 1 ? (v.current && clearInterval(v.current), l(!1), i.refreshToken(), 0) : q - 1);
      }, 1e3));
    };
    C.current = setInterval(b, 60 * 1e3), b();
  }, [i, U, Y]), se = L(() => {
    _.current && clearTimeout(_.current), v.current && clearInterval(v.current), l(!1), y(0), $();
  }, [$]);
  return te(() => (r.user && !r.isLoading && P && $(), () => {
    C.current && clearInterval(C.current);
  }), [r.user, r.isLoading, P, $]), {
    user: r.user,
    isLoading: r.isLoading,
    error: r.error,
    logout: ae,
    getToken: O,
    addAuthHeader: E,
    // Refresh-related
    showRefreshWarning: T,
    refreshCountdown: j,
    minutesUntilExpiry: (H = r.user) != null && H.token && Be(r.user.token) || 0,
    onRefreshNow: ie,
    onCancelRefresh: se
  };
}
var pe = { exports: {} }, B = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ve;
function Pr() {
  if (Ve) return B;
  Ve = 1;
  var n = me, r = Symbol.for("react.element"), a = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, h = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, T = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(j, y, _) {
    var v, C = {}, P = null, U = null;
    _ !== void 0 && (P = "" + _), y.key !== void 0 && (P = "" + y.key), y.ref !== void 0 && (U = y.ref);
    for (v in y) i.call(y, v) && !T.hasOwnProperty(v) && (C[v] = y[v]);
    if (j && j.defaultProps) for (v in y = j.defaultProps, y) C[v] === void 0 && (C[v] = y[v]);
    return { $$typeof: r, type: j, key: P, ref: U, props: C, _owner: h.current };
  }
  return B.Fragment = a, B.jsx = l, B.jsxs = l, B;
}
var z = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ke;
function Ir() {
  return Ke || (Ke = 1, process.env.NODE_ENV !== "production" && function() {
    var n = me, r = Symbol.for("react.element"), a = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), h = Symbol.for("react.strict_mode"), T = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), j = Symbol.for("react.context"), y = Symbol.for("react.forward_ref"), _ = Symbol.for("react.suspense"), v = Symbol.for("react.suspense_list"), C = Symbol.for("react.memo"), P = Symbol.for("react.lazy"), U = Symbol.for("react.offscreen"), Y = Symbol.iterator, N = "@@iterator";
    function ae(e) {
      if (e === null || typeof e != "object")
        return null;
      var t = Y && e[Y] || e[N];
      return typeof t == "function" ? t : null;
    }
    var O = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function E(e) {
      {
        for (var t = arguments.length, o = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)
          o[s - 1] = arguments[s];
        ie("error", e, o);
      }
    }
    function ie(e, t, o) {
      {
        var s = O.ReactDebugCurrentFrame, f = s.getStackAddendum();
        f !== "" && (t += "%s", o = o.concat([f]));
        var d = o.map(function(u) {
          return String(u);
        });
        d.unshift("Warning: " + t), Function.prototype.apply.call(console[e], console, d);
      }
    }
    var $ = !1, se = !1, H = !1, k = !1, b = !1, I;
    I = Symbol.for("react.module.reference");
    function q(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === i || e === T || b || e === h || e === _ || e === v || k || e === U || $ || se || H || typeof e == "object" && e !== null && (e.$$typeof === P || e.$$typeof === C || e.$$typeof === l || e.$$typeof === j || e.$$typeof === y || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === I || e.getModuleId !== void 0));
    }
    function qe(e, t, o) {
      var s = e.displayName;
      if (s)
        return s;
      var f = t.displayName || t.name || "";
      return f !== "" ? o + "(" + f + ")" : o;
    }
    function Re(e) {
      return e.displayName || "Context";
    }
    function F(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && E("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case i:
          return "Fragment";
        case a:
          return "Portal";
        case T:
          return "Profiler";
        case h:
          return "StrictMode";
        case _:
          return "Suspense";
        case v:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case j:
            var t = e;
            return Re(t) + ".Consumer";
          case l:
            var o = e;
            return Re(o._context) + ".Provider";
          case y:
            return qe(e, e.render, "ForwardRef");
          case C:
            var s = e.displayName || null;
            return s !== null ? s : F(e.type) || "Memo";
          case P: {
            var f = e, d = f._payload, u = f._init;
            try {
              return F(u(d));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var D = Object.assign, V = 0, ye, Ce, Te, Ee, be, xe, we;
    function Se() {
    }
    Se.__reactDisabledLog = !0;
    function Ge() {
      {
        if (V === 0) {
          ye = console.log, Ce = console.info, Te = console.warn, Ee = console.error, be = console.group, xe = console.groupCollapsed, we = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: Se,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        V++;
      }
    }
    function Xe() {
      {
        if (V--, V === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: D({}, e, {
              value: ye
            }),
            info: D({}, e, {
              value: Ce
            }),
            warn: D({}, e, {
              value: Te
            }),
            error: D({}, e, {
              value: Ee
            }),
            group: D({}, e, {
              value: be
            }),
            groupCollapsed: D({}, e, {
              value: xe
            }),
            groupEnd: D({}, e, {
              value: we
            })
          });
        }
        V < 0 && E("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ce = O.ReactCurrentDispatcher, ue;
    function G(e, t, o) {
      {
        if (ue === void 0)
          try {
            throw Error();
          } catch (f) {
            var s = f.stack.trim().match(/\n( *(at )?)/);
            ue = s && s[1] || "";
          }
        return `
` + ue + e;
      }
    }
    var le = !1, X;
    {
      var Ze = typeof WeakMap == "function" ? WeakMap : Map;
      X = new Ze();
    }
    function _e(e, t) {
      if (!e || le)
        return "";
      {
        var o = X.get(e);
        if (o !== void 0)
          return o;
      }
      var s;
      le = !0;
      var f = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var d;
      d = ce.current, ce.current = null, Ge();
      try {
        if (t) {
          var u = function() {
            throw Error();
          };
          if (Object.defineProperty(u.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(u, []);
            } catch (S) {
              s = S;
            }
            Reflect.construct(e, [], u);
          } else {
            try {
              u.call();
            } catch (S) {
              s = S;
            }
            e.call(u.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (S) {
            s = S;
          }
          e();
        }
      } catch (S) {
        if (S && s && typeof S.stack == "string") {
          for (var c = S.stack.split(`
`), w = s.stack.split(`
`), p = c.length - 1, m = w.length - 1; p >= 1 && m >= 0 && c[p] !== w[m]; )
            m--;
          for (; p >= 1 && m >= 0; p--, m--)
            if (c[p] !== w[m]) {
              if (p !== 1 || m !== 1)
                do
                  if (p--, m--, m < 0 || c[p] !== w[m]) {
                    var A = `
` + c[p].replace(" at new ", " at ");
                    return e.displayName && A.includes("<anonymous>") && (A = A.replace("<anonymous>", e.displayName)), typeof e == "function" && X.set(e, A), A;
                  }
                while (p >= 1 && m >= 0);
              break;
            }
        }
      } finally {
        le = !1, ce.current = d, Xe(), Error.prepareStackTrace = f;
      }
      var J = e ? e.displayName || e.name : "", W = J ? G(J) : "";
      return typeof e == "function" && X.set(e, W), W;
    }
    function Qe(e, t, o) {
      return _e(e, !1);
    }
    function er(e) {
      var t = e.prototype;
      return !!(t && t.isReactComponent);
    }
    function Z(e, t, o) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return _e(e, er(e));
      if (typeof e == "string")
        return G(e);
      switch (e) {
        case _:
          return G("Suspense");
        case v:
          return G("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case y:
            return Qe(e.render);
          case C:
            return Z(e.type, t, o);
          case P: {
            var s = e, f = s._payload, d = s._init;
            try {
              return Z(d(f), t, o);
            } catch {
            }
          }
        }
      return "";
    }
    var K = Object.prototype.hasOwnProperty, ke = {}, Ae = O.ReactDebugCurrentFrame;
    function Q(e) {
      if (e) {
        var t = e._owner, o = Z(e.type, e._source, t ? t.type : null);
        Ae.setExtraStackFrame(o);
      } else
        Ae.setExtraStackFrame(null);
    }
    function rr(e, t, o, s, f) {
      {
        var d = Function.call.bind(K);
        for (var u in e)
          if (d(e, u)) {
            var c = void 0;
            try {
              if (typeof e[u] != "function") {
                var w = Error((s || "React class") + ": " + o + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw w.name = "Invariant Violation", w;
              }
              c = e[u](t, u, s, o, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (p) {
              c = p;
            }
            c && !(c instanceof Error) && (Q(f), E("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", s || "React class", o, u, typeof c), Q(null)), c instanceof Error && !(c.message in ke) && (ke[c.message] = !0, Q(f), E("Failed %s type: %s", o, c.message), Q(null));
          }
      }
    }
    var tr = Array.isArray;
    function fe(e) {
      return tr(e);
    }
    function nr(e) {
      {
        var t = typeof Symbol == "function" && Symbol.toStringTag, o = t && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return o;
      }
    }
    function or(e) {
      try {
        return je(e), !1;
      } catch {
        return !0;
      }
    }
    function je(e) {
      return "" + e;
    }
    function Pe(e) {
      if (or(e))
        return E("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", nr(e)), je(e);
    }
    var Ie = O.ReactCurrentOwner, ar = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Oe, Fe;
    function ir(e) {
      if (K.call(e, "ref")) {
        var t = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (t && t.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function sr(e) {
      if (K.call(e, "key")) {
        var t = Object.getOwnPropertyDescriptor(e, "key").get;
        if (t && t.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function cr(e, t) {
      typeof e.ref == "string" && Ie.current;
    }
    function ur(e, t) {
      {
        var o = function() {
          Oe || (Oe = !0, E("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", t));
        };
        o.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: o,
          configurable: !0
        });
      }
    }
    function lr(e, t) {
      {
        var o = function() {
          Fe || (Fe = !0, E("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", t));
        };
        o.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: o,
          configurable: !0
        });
      }
    }
    var fr = function(e, t, o, s, f, d, u) {
      var c = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: e,
        key: t,
        ref: o,
        props: u,
        // Record the component responsible for creating this element.
        _owner: d
      };
      return c._store = {}, Object.defineProperty(c._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(c, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: s
      }), Object.defineProperty(c, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: f
      }), Object.freeze && (Object.freeze(c.props), Object.freeze(c)), c;
    };
    function dr(e, t, o, s, f) {
      {
        var d, u = {}, c = null, w = null;
        o !== void 0 && (Pe(o), c = "" + o), sr(t) && (Pe(t.key), c = "" + t.key), ir(t) && (w = t.ref, cr(t, f));
        for (d in t)
          K.call(t, d) && !ar.hasOwnProperty(d) && (u[d] = t[d]);
        if (e && e.defaultProps) {
          var p = e.defaultProps;
          for (d in p)
            u[d] === void 0 && (u[d] = p[d]);
        }
        if (c || w) {
          var m = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          c && ur(u, m), w && lr(u, m);
        }
        return fr(e, c, w, f, s, Ie.current, u);
      }
    }
    var de = O.ReactCurrentOwner, Ue = O.ReactDebugCurrentFrame;
    function M(e) {
      if (e) {
        var t = e._owner, o = Z(e.type, e._source, t ? t.type : null);
        Ue.setExtraStackFrame(o);
      } else
        Ue.setExtraStackFrame(null);
    }
    var he;
    he = !1;
    function ge(e) {
      return typeof e == "object" && e !== null && e.$$typeof === r;
    }
    function De() {
      {
        if (de.current) {
          var e = F(de.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function hr(e) {
      return "";
    }
    var We = {};
    function gr(e) {
      {
        var t = De();
        if (!t) {
          var o = typeof e == "string" ? e : e.displayName || e.name;
          o && (t = `

Check the top-level render call using <` + o + ">.");
        }
        return t;
      }
    }
    function Le(e, t) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var o = gr(t);
        if (We[o])
          return;
        We[o] = !0;
        var s = "";
        e && e._owner && e._owner !== de.current && (s = " It was passed a child from " + F(e._owner.type) + "."), M(e), E('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', o, s), M(null);
      }
    }
    function Ne(e, t) {
      {
        if (typeof e != "object")
          return;
        if (fe(e))
          for (var o = 0; o < e.length; o++) {
            var s = e[o];
            ge(s) && Le(s, t);
          }
        else if (ge(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var f = ae(e);
          if (typeof f == "function" && f !== e.entries)
            for (var d = f.call(e), u; !(u = d.next()).done; )
              ge(u.value) && Le(u.value, t);
        }
      }
    }
    function vr(e) {
      {
        var t = e.type;
        if (t == null || typeof t == "string")
          return;
        var o;
        if (typeof t == "function")
          o = t.propTypes;
        else if (typeof t == "object" && (t.$$typeof === y || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        t.$$typeof === C))
          o = t.propTypes;
        else
          return;
        if (o) {
          var s = F(t);
          rr(o, e.props, "prop", s, e);
        } else if (t.PropTypes !== void 0 && !he) {
          he = !0;
          var f = F(t);
          E("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", f || "Unknown");
        }
        typeof t.getDefaultProps == "function" && !t.getDefaultProps.isReactClassApproved && E("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function pr(e) {
      {
        for (var t = Object.keys(e.props), o = 0; o < t.length; o++) {
          var s = t[o];
          if (s !== "children" && s !== "key") {
            M(e), E("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", s), M(null);
            break;
          }
        }
        e.ref !== null && (M(e), E("Invalid attribute `ref` supplied to `React.Fragment`."), M(null));
      }
    }
    var $e = {};
    function Me(e, t, o, s, f, d) {
      {
        var u = q(e);
        if (!u) {
          var c = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (c += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var w = hr();
          w ? c += w : c += De();
          var p;
          e === null ? p = "null" : fe(e) ? p = "array" : e !== void 0 && e.$$typeof === r ? (p = "<" + (F(e.type) || "Unknown") + " />", c = " Did you accidentally export a JSX literal instead of a component?") : p = typeof e, E("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", p, c);
        }
        var m = dr(e, t, o, f, d);
        if (m == null)
          return m;
        if (u) {
          var A = t.children;
          if (A !== void 0)
            if (s)
              if (fe(A)) {
                for (var J = 0; J < A.length; J++)
                  Ne(A[J], e);
                Object.freeze && Object.freeze(A);
              } else
                E("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ne(A, e);
        }
        if (K.call(t, "key")) {
          var W = F(e), S = Object.keys(t).filter(function(Er) {
            return Er !== "key";
          }), ve = S.length > 0 ? "{key: someKey, " + S.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!$e[W + ve]) {
            var Tr = S.length > 0 ? "{" + S.join(": ..., ") + ": ...}" : "{}";
            E(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, ve, W, Tr, W), $e[W + ve] = !0;
          }
        }
        return e === i ? pr(m) : vr(m), m;
      }
    }
    function mr(e, t, o) {
      return Me(e, t, o, !0);
    }
    function Rr(e, t, o) {
      return Me(e, t, o, !1);
    }
    var yr = Rr, Cr = mr;
    z.Fragment = i, z.jsx = yr, z.jsxs = Cr;
  }()), z;
}
process.env.NODE_ENV === "production" ? pe.exports = Pr() : pe.exports = Ir();
var g = pe.exports;
function Or({
  minutesUntilExpiry: n,
  secondsRemaining: r,
  onRefreshNow: a,
  onCancel: i
}) {
  return /* @__PURE__ */ g.jsx(
    "div",
    {
      style: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999
      },
      children: /* @__PURE__ */ g.jsxs(
        "div",
        {
          style: {
            backgroundColor: "white",
            borderRadius: "8px",
            padding: "24px",
            maxWidth: "500px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
          },
          children: [
            /* @__PURE__ */ g.jsx("div", { style: { marginBottom: "16px" }, children: /* @__PURE__ */ g.jsx("h2", { style: { margin: 0, fontSize: "20px", fontWeight: "600" }, children: "Session Expiring Soon" }) }),
            /* @__PURE__ */ g.jsxs("div", { style: { marginBottom: "20px", color: "#4b5563" }, children: [
              /* @__PURE__ */ g.jsxs("p", { style: { margin: "0 0 12px 0" }, children: [
                "Your session will expire in",
                " ",
                /* @__PURE__ */ g.jsxs("strong", { children: [
                  n,
                  " minute",
                  n !== 1 ? "s" : ""
                ] }),
                "."
              ] }),
              /* @__PURE__ */ g.jsxs("p", { style: { margin: 0 }, children: [
                "Please save your work. The session will automatically refresh in",
                " ",
                /* @__PURE__ */ g.jsxs("strong", { style: { color: "#dc2626" }, children: [
                  r,
                  " second",
                  r !== 1 ? "s" : ""
                ] }),
                "."
              ] })
            ] }),
            /* @__PURE__ */ g.jsxs(
              "div",
              {
                style: {
                  display: "flex",
                  gap: "12px",
                  justifyContent: "flex-end"
                },
                children: [
                  /* @__PURE__ */ g.jsx(
                    "button",
                    {
                      onClick: i,
                      style: {
                        padding: "8px 16px",
                        border: "1px solid #d1d5db",
                        borderRadius: "6px",
                        backgroundColor: "white",
                        color: "#374151",
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: "500"
                      },
                      onMouseOver: (h) => {
                        h.currentTarget.style.backgroundColor = "#f9fafb";
                      },
                      onMouseOut: (h) => {
                        h.currentTarget.style.backgroundColor = "white";
                      },
                      children: "Stay on Page"
                    }
                  ),
                  /* @__PURE__ */ g.jsx(
                    "button",
                    {
                      onClick: a,
                      style: {
                        padding: "8px 16px",
                        border: "none",
                        borderRadius: "6px",
                        backgroundColor: "#2563eb",
                        color: "white",
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: "500"
                      },
                      onMouseOver: (h) => {
                        h.currentTarget.style.backgroundColor = "#1d4ed8";
                      },
                      onMouseOut: (h) => {
                        h.currentTarget.style.backgroundColor = "#2563eb";
                      },
                      children: "Refresh Now"
                    }
                  )
                ]
              }
            )
          ]
        }
      )
    }
  );
}
const He = wr(
  void 0
);
function Nr({
  config: n,
  children: r,
  loadingComponent: a,
  errorComponent: i,
  onAccessGranted: h,
  onAccessDenied: T
}) {
  const l = jr(n);
  if (me.useEffect(() => {
    l.isLoading || (l.user && h ? h(!0, l.user) : l.error && T && T());
  }, [l.isLoading, l.user, l.error, h, T]), l.isLoading)
    return /* @__PURE__ */ g.jsx(g.Fragment, { children: a || /* @__PURE__ */ g.jsx("div", { className: "flex items-center justify-center min-h-screen", children: /* @__PURE__ */ g.jsx("div", { className: "text-center", children: /* @__PURE__ */ g.jsx("div", { className: "text-lg", children: "Authenticating..." }) }) }) });
  if (l.error)
    return /* @__PURE__ */ g.jsx(g.Fragment, { children: i ? i(l.error) : /* @__PURE__ */ g.jsx("div", { className: "flex items-center justify-center min-h-screen", children: /* @__PURE__ */ g.jsx("div", { className: "text-center", children: /* @__PURE__ */ g.jsxs("div", { className: "text-lg text-red-600", children: [
      "Authentication Error: ",
      l.error
    ] }) }) }) });
  const j = n.refreshWarningComponent || Or;
  return /* @__PURE__ */ g.jsxs(He.Provider, { value: l, children: [
    r,
    l.showRefreshWarning && /* @__PURE__ */ g.jsx(
      j,
      {
        minutesUntilExpiry: l.minutesUntilExpiry,
        secondsRemaining: l.refreshCountdown,
        onRefreshNow: l.onRefreshNow,
        onCancel: l.onCancelRefresh
      }
    )
  ] });
}
function $r() {
  const n = Sr(He);
  if (n === void 0)
    throw new Error("useCASAuthContext must be used within a CASAuthProvider");
  return n;
}
function Fr(n = ne, r = "cas_jwt") {
  n.interceptors.request.use(
    (a) => {
      const i = R.getToken(r);
      return i && a.headers && (a.headers.Authorization = `Bearer ${i}`), a;
    },
    (a) => Promise.reject(a)
  ), n.interceptors.response.use(
    (a) => a,
    (a) => {
      var i;
      return ((i = a.response) == null ? void 0 : i.status) === 401 && console.warn("[CAS Auth] Received 401, token may be expired"), Promise.reject(a);
    }
  );
}
function Mr(n, r = "cas_jwt") {
  const a = ne.create({
    baseURL: n
  });
  return Fr(a, r), a;
}
export {
  Ar as CASAuthManager,
  Nr as CASAuthProvider,
  Or as RefreshWarningDialog,
  x as StorageKeys,
  Mr as createAuthenticatedAxios,
  oe as decodeJWT,
  ze as extractUserFromToken,
  Be as getTokenExpirationMinutes,
  Lr as getTokenExpirationSeconds,
  _r as isTokenExpired,
  Fr as setupAxiosInterceptor,
  kr as shouldRefreshToken,
  R as storage,
  jr as useCASAuth,
  $r as useCASAuthContext,
  Ye as validateToken
};
